import { Moment } from 'moment';
import { Instituicao } from './instituicao.model';
import { TipoResponsavel } from './tipo-responsavel.model';

export class ResponsavelInstituicao {
  id: number;
  instituicao: Instituicao;
  idPessoa: number;
  tipoResponsavel: TipoResponsavel;
  email: string;
  telefone: number;
  dataInicioVinculo: Moment;
  dataFimVinculo: Moment;
  nome: string;

  constructor(init?: Partial<ResponsavelInstituicao>) {
    Object.assign(this, init);
  }
}
